import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { isDefined } from '@fabric-app/utils/guards';
import { useState } from 'react';

const useTextAreaAutoResize = (ref, textAreaValue, { minHeight = 17, maxHeight = 68 }) => {
  const [height, setHeight] = useState(17);
  useClientLayoutEffect(() => {
    const textArea = isDefined(ref) && "current" in ref ? ref.current : ref;
    if (!textArea) return;
    textArea.style.height = "auto";
    textArea.style.height = textArea.scrollHeight + "px";
    textArea.scrollTop = textArea.scrollHeight;
    const rect = textArea.getBoundingClientRect();
    setHeight(Math.min(maxHeight, Math.max(minHeight, rect.height)));
  }, [
    isDefined(ref) && "current" in ref ? ref.current : ref,
    textAreaValue,
    minHeight,
    maxHeight
  ]);
  return height;
};

export { useTextAreaAutoResize };
//# sourceMappingURL=useTextAreaAutoResize.js.map
